import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faTools, faHome, faUsers, faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom'; // For navigation


const Livelihood: React.FC = () => {
  const navigate = useNavigate(); // Hook for navigation

  const handleDonateClick = () => {
    navigate('/donate');
  };

  return (
    <div className="livelihood-page">
      {/* Section 1: Hero Section with Background Image and Overlay */}
      <div className="hero-section" style={{ backgroundImage: `url('https://i.pinimg.com/736x/47/d3/f1/47d3f14b5daecf5d694e4885c096f23f.jpg')` }}>
        <div className="overlay">
          <Container className="text-center py-5">
            <h1 className="hero-title">Building Sustainable Livelihoods</h1>
            <p className="hero-subtitle">Equipping communities with essential skills and opportunities to create lasting, self-sustaining futures.</p>
            <Button className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Container>
        </div>
      </div>

      {/* Section 2: Our Mission */}
      <Container className="my-5">
        <Row className="align-items-center">
          <Col md={6}>
            <img
              src="https://i.pinimg.com/736x/3b/1f/07/3b1f0775718ac692be8c83b3be78208b.jpg"
              alt="Community Work"
              className="img-fluid "
            />
          </Col>
          <Col md={6}>
            <h2 className="section-title"><FontAwesomeIcon icon={faHandHoldingUsd} className="me-2" /> Our Mission</h2>
            <p className="section-text">
              At Srisailam Foundation, we are dedicated to improving livelihoods by offering vocational training, microfinance opportunities, and housing support to uplift underserved communities across India.
            </p>
            <Button className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Section 3: Livelihood Programs */}
      <Container className="my-5 py-5" style={{ backgroundColor: '#F3F4F6' }}>
        <h2 className="text-center section-title mb-5"><FontAwesomeIcon icon={faBriefcase} className="me-2" /> Livelihood Programs</h2>
        <Row className="g-4">
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://kashmirconvener.com/wp-content/uploads/2025/02/360_F_677241119_W74KARdZABhhXcjhoev5DO0uuPdOQCHZ.jpg" alt="Vocational Training" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Vocational Training</Card.Title>
                <Card.Text className="card-text">
                  Providing skill development in trades such as carpentry, tailoring, and IT to empower individuals with sustainable livelihoods.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://cdn.corporatefinanceinstitute.com/assets/microfinance.jpeg" alt="Microfinance" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Microfinance</Card.Title>
                <Card.Text className="card-text">
                  Offering small loans to help individuals start or expand small businesses, fostering entrepreneurship and financial independence..
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://i0.wp.com/www.india-briefing.com/news/wp-content/uploads/2021/11/MicrosoftTeams-image-6.jpg?fit=900%2C506&ssl=1" alt="Agriculture Support" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Agriculture Support</Card.Title>
                <Card.Text className="card-text">
                  Providing training and resources to promote sustainable farming practices, ensuring long-term agricultural success and environmental stewardship.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Section 4: Housing Initiatives */}
      <Container className="my-5">
        <Row className="align-items-center flex-row-reverse">
          <Col md={6}>
            <img
              src="https://i.pinimg.com/736x/49/b9/e2/49b9e20f7af5d76a9e73eeedff4fcb74.jpg"
              alt="Housing Project"
              className="img-fluid"
            />
          </Col>
          <Col md={6}>
            <h2 className="section-title"><FontAwesomeIcon icon={faHome} className="me-2" /> Housing Initiatives</h2>
            <p className="section-text">
              Offering affordable housing solutions and infrastructure development to improve living conditions for low-income families.
            </p>
            <Button className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Section 5: Community Empowerment */}
      <Container className="my-5 py-5" style={{ backgroundColor: '#E5E7EB' }}>
        <h2 className="text-center section-title mb-5"><FontAwesomeIcon icon={faUsers} className="me-2" /> Community Empowerment</h2>
        <Row className="g-4">
          <Col md={6}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://www.indiafilings.com/learn/wp-content/uploads/2019/07/Skill-Training-for-Rural-Youth.jpg" alt="Skill Workshops" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Skill Workshops</Card.Title>
                <Card.Text className="card-text">
                  Providing hands-on training to boost employability and create income-generating opportunities..
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Img variant="top" src="https://www.taxscan.in/wp-content/uploads/2024/10/ITAT-Income-Tax-Appellate-Tribunal-ITAT-AHMEDABAD-Section-80P-cooperative-societies-growth-of-cooperative-societies-TAXSCAN.jpg" alt="Cooperative Societies" />
              <Card.Body className="text-center">
                <Card.Title className="card-title">Cooperative Societies</Card.Title>
                <Card.Text className="card-text">
                  Empowering communities by supporting collective businesses, fostering economic stability and growth.
                </Card.Text>
                <Button className="donate-btn" size="sm" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Section 6: Call to Action */}
      <Container className="my-5 text-center py-5" style={{ backgroundColor: 'gray', color: '#FFFFFF' }}>
        <h2 className="section-title mb-4 text-white">Support Sustainable Livelihoods</h2>
        <p className="section-text mb-4 text-white">
          Your contribution can empower individuals and create lasting opportunities. Join us today to make a difference!
        </p>
        <Button className="donate-btn" size="lg" onClick={handleDonateClick}>
          Donate Us
        </Button>
      </Container>
    </div>
  );
};

export default Livelihood;